import { KeyRound } from 'lucide-react';
import { useState } from 'react';
import { useAddOnboarding } from '@/api/studio';
import { Dialog } from '@/components/ui';
import { errorMessage } from '@/lib/errors';

/** Ask the client for an access at any time, not only in «Запуск»: an onboarding item of kind «access» and scope «access», shown in the tab «Доступы», not in the launch checklist. */
export function RequestAccess({ projectId }: { projectId: string }) {
  const add = useAddOnboarding();
  const [open, setOpen] = useState(false);
  const [title, setTitle] = useState('');
  const [hint, setHint] = useState('');
  const close = () => {
    setOpen(false);
    setTitle('');
    setHint('');
    add.reset();
  };
  return (
    <>
      <button className="btn-secondary" onClick={() => setOpen(true)}>
        <KeyRound className="size-4" /> Запросить доступ
      </button>
      <Dialog open={open} onClose={close} title="Запросить доступ у клиента">
        <form
          className="space-y-4 p-5"
          onSubmit={(e) => {
            e.preventDefault();
            if (!title.trim()) return;
            add.mutate({ projectId, item: { kind: 'access', scope: 'access', title: title.trim(), hint: hint.trim() } }, { onSuccess: close });
          }}
        >
          <p className="text-sm text-muted">Клиент получит уведомление и увидит запрос в «Сейчас» и «Доступах» с кнопкой «Передать».</p>
          <input className="field" placeholder="Что нужно, например «Авито»" value={title} onChange={(e) => setTitle(e.target.value)} autoFocus />
          <input className="field" placeholder="Подсказка клиенту" value={hint} onChange={(e) => setHint(e.target.value)} />
          {add.error && (
            <p role="alert" className="text-sm text-overdue">
              {errorMessage(add.error)}
            </p>
          )}
          <div className="flex justify-end border-t border-line pt-4">
            <button className="btn-primary" disabled={!title.trim() || add.isPending}>
              Запросить
            </button>
          </div>
        </form>
      </Dialog>
    </>
  );
}
